export function parseData(data, key) {
    if (!data) return null;
    if(key) {
        let _data = JSON.parse(data);
        return _data[key];
    } else {
        return JSON.stringify(data);
    }
}